import { z } from 'zod';
const MapPointValidationSchema = z.object({
    type: z.string(),
    coordinates: z.array(z.number()).length(2)
});
export { MapPointValidationSchema };
//# sourceMappingURL=mapPoint.js.map